import React, { useEffect, useRef, useState } from "react";

// Correction (±) input: always shows a number; 0 = green, anything else = red. Focus selects all (Excel-like).
export function OffsetInput({ testId, value, onCommit, onKeyDown, onFocus, title, className = "w-12 py-1" }) {
    const [draft, setDraft] = useState(null);
    const committed = useRef(false);
    const justFocused = useRef(false);
    useEffect(() => {
        if (committed.current) { committed.current = false; return; }
        if (draft !== null) setDraft(String(value));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);
    const shown = draft ?? String(value);
    const corrected = Number(shown === "-" || shown === "" ? value : shown) !== 0;
    return (
        <input data-testid={testId} data-cell="1" type="text" inputMode="decimal" title={title}
            data-corrected={corrected ? "1" : "0"}
            value={shown}
            onClick={(e) => e.stopPropagation()}
            onMouseUp={(e) => { if (justFocused.current) { e.preventDefault(); justFocused.current = false; } }}
            onFocus={(e) => {
                const el = e.target;
                setDraft(String(value)); committed.current = false; justFocused.current = true; onFocus?.();
                el.select(); requestAnimationFrame(() => { if (document.activeElement === el) el.select(); });
            }}
            onBlur={() => { setDraft(null); justFocused.current = false; }}
            onKeyDown={onKeyDown}
            onChange={(e) => {
                justFocused.current = false;
                let s = e.target.value.replace(",", ".");
                if (/^0[-\d]/.test(s)) s = s.slice(1);
                if (/^\d*-\d*$/.test(s) && !s.startsWith("-")) s = "-" + s.replace("-", "");
                if (!/^-?\d*\.?\d*$/.test(s)) return;
                setDraft(s);
                const n = Number(s);
                const v = s === "" || s === "-" || s === "." || Number.isNaN(n) ? null : n;
                committed.current = Number(v ?? NaN) !== Number(value);
                onCommit(v);
            }}
            className={`${className} bg-transparent text-xs font-semibold px-1 rounded focus:bg-[#0b0f17] focus:outline-none focus:ring-2 text-right font-mono ${corrected ? "text-rose-400 focus:ring-rose-500/70" : "text-emerald-400 focus:ring-teal-500/70"}`} />
    );
}
